import type {
  ClaimEvidenceMap,
  GroundedAnswerMode,
  GroundedCompareInput,
  GroundingBudget,
} from "@gencow/core";

export function buildTargetedResearchQueries(params: {
  question: string;
  claims: ClaimEvidenceMap[];
  mode: GroundedAnswerMode;
  compare?: GroundedCompareInput;
  budget: GroundingBudget;
}): string[] {
  const queries: string[] = [];
  for (const claim of params.claims) {
    if (claim.status === "supported") continue;
    queries.push(claim.claimText);

    if (params.mode === "compare" && params.compare) {
      queries.push(`${params.compare.left} ${claim.claimText}`);
      queries.push(`${params.compare.right} ${claim.claimText}`);
    }

    for (const reason of claim.missingEvidenceReasons ?? []) {
      queries.push(`${params.question} ${reason}`);
    }
  }

  return dedupeQueries(queries).slice(0, params.budget.maxResearchQueriesPerLoop);
}

function dedupeQueries(queries: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const query of queries) {
    const normalized = query.replace(/\s+/g, " ").trim();
    const key = normalized.toLowerCase();
    if (!normalized || seen.has(key)) continue;
    seen.add(key);
    result.push(normalized);
  }
  return result;
}
